module.exports = __webpack_public_path__ + "img/seatides.8c8a0b94.svg";